import { useStore } from 'zustand';
import type { EagGridState } from './createEagGridStore';
import { useEagGridStore } from './useEagGridStore';
export function useEagGridSelector(selector) {
  const store = useEagGridStore();
  return useStore(store, selector);
}